export const TIME_TRACKING_REPORT_STATE = 'reports.time-tracking.state'

export const TIMELINE_REPORT_STATE = 'reports.timeline.state'

export const LAST_OPENED_BOARD_STATE = 'boards.last-opened'

export const VIEW_TYPE = 'boards.view.board-view'

export const LAST_OPENED_THREAD_STATE = 'threads.last-opened'

export const REMINDERS_FILTER_STATE = 'reminders.filter.state'

export const SHOW_ACTIVITY_LOG_STATE = 'activity.log.state'

export const PROJECT_IMPORT_STATE = 'project-import-in-progress'

export const AUTH_LOGOUT_STATE = 'auth.logout'

export const BROWSER_NOTIFICATION_PERMISSION_REQUESTED =
  'notifications.browser-notifications-requested'

export const createBoardListViewExpandedRowsStorageKey = (boardId: string) =>
  `board.${boardId}.expanded-rows`

export {
  clearState,
  getStoredState,
  storeState,
} from '@mono/packages/utils/localStorage'
